import { render, staticRenderFns } from "./SubmissionForm.vue?vue&type=template&id=cac325f2&scoped=true&"
import script from "./SubmissionForm.vue?vue&type=script&lang=js&"
export * from "./SubmissionForm.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionForm.vue?vue&type=style&index=0&id=cac325f2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac325f2",
  null
  
)

/* custom blocks */
import block0 from "./SubmissionForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports